/**
 *  @class
 *  @function MegaMenuSidebar
 *
 *  Switches the level-3 grid and the brand strip when a level-2 category in the
 *  sidebar is hovered or focused. One delegated listener per menu, no timers and
 *  no animation loop: the brand crawler is a CSS marquee that only runs while the
 *  mega menu is open.
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    connectedCallback() {
      this.sidebar = this.querySelector('.mega-menu-sidebar--sidebar');
      if (!this.sidebar) return;

      this.onSelect = this.onSelect.bind(this);
      this.sidebar.addEventListener('pointerover', this.onSelect);
      this.sidebar.addEventListener('focusin', this.onSelect);
    }

    disconnectedCallback() {
      if (!this.sidebar) return;
      this.sidebar.removeEventListener('pointerover', this.onSelect);
      this.sidebar.removeEventListener('focusin', this.onSelect);
    }

    onSelect(event) {
      const button = event.target.closest('.mega-menu-sidebar--button');
      if (!button || button.classList.contains('active')) return;

      const panel = button.dataset.panel;

      this.querySelectorAll('.mega-menu-sidebar--button').forEach((other) => {
        other.classList.toggle('active', other === button);
      });
      // Content grid and brand strip share the same index, so one pass covers both.
      this.querySelectorAll('[data-panel-body]').forEach((body) => {
        body.classList.toggle('active', body.dataset.panelBody === panel);
      });
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
